import {translate} from '@/services/i18n'

export const getNewAssetTitle = (asset: string) => {
  return `${translate('new')} ${asset.toLocaleLowerCase()}`
}
